import script from "./FuelingTransactionDetailCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./FuelingTransactionDetailCard.vue?vue&type=script&setup=true&lang=ts"

import "./FuelingTransactionDetailCard.vue?vue&type=style&index=0&id=5cdd52d1&lang=scss&scoped=true"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cdd52d1"]])

export default __exports__